import { Module } from '../Module';

Module.instance().directive('tbMouseupOutside', <any[]>[
  '$parse',
  ($parse: ng.IParseService) => {
    return {
      link: (scope: ng.IScope, element: JQuery, attr: ng.IAttributes) => {
        const eventNamespace = '.tbMouseupOutside' + scope.$id;
        const upOutsideFn = $parse(attr['tbMouseupOutside']);
        const doc = angular.element(document);
        const mouseupEvents = 'mouseup' + eventNamespace + ' touchend' + eventNamespace;

        doc.on(mouseupEvents, (upEvent: JQuery.Event) => {
          const target = $(upEvent.target);
          if (target.closest(element).length === 0) {
            scope.$apply(() => {
              upOutsideFn(scope, { $event: upEvent });
            });
          }
        });
        element.on('$destroy', () => {
          doc.off(eventNamespace);
        });
      }
    };
  }
]);
